import { useState } from "react";

const initialFormData = {
  first_name: "",
  middle_name: "",
  last_name: "",
  gender: "Male",
  date_of_birth: "",
  national_id: "",
  phone_number: "",
  email: "",
  address: "",
  qualification: "",
  specialization: "",
  employment_date: "",
  employment_status: "Active",
  is_active: true,
  role_id: "",
  password: "",
  password_confirmation: "",
};

export const useTeacherForm = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [editingTeacher, setEditingTeacher] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  const openForm = (teacher = null) => {
    if (teacher) {
      setFormData({
        ...teacher,
        date_of_birth: formatDateForInput(teacher.date_of_birth),
        employment_date: formatDateForInput(teacher.employment_date)
      });
      setEditingTeacher(teacher);
    }
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setShowForm(false);
    setEditingTeacher(null);
  };

  const updateFormData = (updates) => {
    setFormData(prev => ({ ...prev, ...updates }));
  };

  return {
    formData,
    setFormData,
    editingTeacher,
    showForm,
    openForm,
    resetForm,
    updateFormData,
  };
};
